export interface IBreakpoints {
  readonly xSmall: number;
  readonly small: number;
  readonly mediumSmall: number;
  readonly medium: number;
  readonly mediumLarge: number;
}

export const breakpoints: IBreakpoints = {
  xSmall: 375,
  small: 640,
  mediumSmall: 769,
  medium: 1024,
  mediumLarge: 1180,
};
